<template>
    <ai-grid-virtual-wrapper
        ref="objectListRef"
        :custom-context-menu="customContextMenu"
        :meta="objectListMeta"
        :set-context="setContext"
        @gridVirtualWrapperMounted="onGridVirtualWrapperMounted"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import AiGridVirtualWrapper from '@/components/wrappers/ai-grid-virtual-wrapper.vue';
import objectListMeta from '@/views/contracts/object/view-object-list/object-list-meta';
import {
    ContextNames,
    getDefaultContextGroup,
    saveContexts,
    setActiveViewInfo,
    setViewData,
} from '@/layouts/main-layout/main-layout-data';
import { setTabTitle } from '@/layouts/main-layout/components/navigation-bars-data'

const router = useRouter();
const objectListRef = ref();
const objectListNewInstance = ref();

const customContextMenu = [
    {
        text: 'Открыть карточку объекта',
        onItemClick: e => {
            router.push({
                name: 'ObjectCard',
                params: { id: e.itemData.rowData.key },
            });
        },
    },
];

const toolbarButtonClick = async e => {
    if (e.item.component.name === 'edit') {
        const key = objectListRef.value.gridInstance.gridInstance.gridInstance.option('focusedRowKey');
        await router.push({
            name: 'ObjectCard',
            params: { id: key },
        });
    } else if (e.item.component.name === 'add') {
        setTabTitle('Новый объект');
        await router.push({ name: 'ObjectCardNew' });
    } else if (e.item.component.name === 'delete') {
        console.log('delete object card');
    }
};

const setContext = async dataRow => {
    const orgContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    orgContextGroup.contexts.PayerContext = {
        value: dataRow['kodp'],
        userText: dataRow['contragent_name'],
    };
    orgContextGroup.contexts.DogContext = {
        value: dataRow['kod_dog'],
        userText: dataRow['ndog'],
    };
    orgContextGroup.contexts.NumObjContext = {
        value: dataRow['kod_numobj'],
        userText: `${dataRow['num_obj']} ${dataRow['name']}`,
    };
    await saveContexts({
        nameGroup: ContextNames.ORG_CONTEXT_GROUP,
        value: orgContextGroup,
    });
};

const onGridVirtualWrapperMounted = async () => {
    objectListNewInstance.value = {
        refresh: () => {},
        userData: () => {},
        userSettings: objectListRef.value.fetchAndSetUserSettings,
    };
    setActiveViewInfo(objectListNewInstance.value);
    await setViewData();
};
</script>
<script>
export default {
    name: 'view-object-list',
};
</script>
